import { IWorkflowFactoryTriggerResult } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

/** Trigger an automated research + workflow build for the selected filings (by compositeId). Returns the
 * split of what enqueued, what was skipped because a run was already in flight, and what was missing from
 * the active content slot. Internal-only. */
export async function triggerWorkflowFactory(
  compositeIds: string[]
): Promise<{ success: boolean; data?: IWorkflowFactoryTriggerResult }> {
  try {
    const res = await fetcher(`${BASE_URL}/trigger`, {
      method: 'POST',
      body: { compositeIds },
    });
    if (!res.ok) return { success: false, data: undefined };
    const data = (await res.json()) as IWorkflowFactoryTriggerResult;
    return { success: true, data };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
